module.exports = __webpack_public_path__ + "static/date_sp-cfdb752f9840cb4e72b1fc79da80afca.svg";